export const language = {
  th: {
    title: "รายการเบิกเงิน",
    adddata: "เพิ่ม",
    name: "เบิกเงินล่วงหน้า",
    labelsearch: "ค้นหาหมายเลขเบิกเงิน",
    headertable: [{
        text: "เลขที่",
        value: "no",
      },
      {
        text: "วันที่เปิด",
        value: "date_show",
      },
      {
        text: "ชื่อ",
        value: "name",
      },
      {
        text: "ลูกค้า",
        value: "customer",
      },
      {
        text: "จำนวนเงิน",
        value: "amount",
      },
      {
        text: "สถานะ",
        value: "status",
      },
      {
        text: "",
        value: "actions",
      },
      // {
      //     text: "Actions",
      //     value: "actions",
      //     sortable: false
      // }
    ],
  },
  en: {
    title: "My Advance",
    adddata: "Filter",
    name: "advance",
    labelsearch: "Search",
    headertable: [{
        text: "Document No.",
        value: "no",
        class: "bg-colorth tabletextwhite",
      },
      {
        text: "Date",
        value: "date_show",
        class: "bg-colorth tabletextwhite",
      },
      {
        text: "Name",
        value: "name",
        class: "bg-colorth tabletextwhite",
      },
      {
        text: "Customer",
        value: "customer",
        class: "bg-colorth tabletextwhite",
      },
      {
        text: "Amount",
        value: "amount",
        class: "bg-colorth tabletextwhite",
      },
      {
        text: "Status",
        value: "status",
        class: "bg-colorth tabletextwhite",
      },
      {
        text: "",
        value: "actions",
        class: "bg-colorth tabletextwhite",
      },
      // {
      //     text: "Actions",
      //     value: "actions",
      //     sortable: false
      // },
    ],
  },
};